import React from "react";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-obsidian-900 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="font-bebas text-2xl text-white">
            LUCAS<span className="text-gold-400">JUMALON</span>POKER<span className="text-gold-400">.AI</span>
          </div>
          <p className="text-zinc-400 text-sm mt-3 max-w-sm">
            Training and Boot Camps from the 2026 WSOP Main Event Champion. No fluff, just the moves that matter.
          </p>
        </div>
        <div>
          <div className="font-bebas text-gold-400 text-lg uppercase mb-3">Learn</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><a href="/#poker-101" className="hover:text-white">POKER 101 Modules</a></li>
            <li><a href="/#lucas-style" className="hover:text-white">Poker Lucas Style</a></li>
            <li><a href="/#bootcamp" className="hover:text-white">Boot Camp Sessions</a></li>
            <li><a href="/#merch" className="hover:text-white">Signature Merch</a></li>
          </ul>
        </div>
        <div>
          <div className="font-bebas text-gold-400 text-lg uppercase mb-3">Champion</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><a href="/#faq" className="hover:text-white">FAQ</a></li>
            <li><a href="/#contact" className="hover:text-white">Press &amp; Booking</a></li>
            <li><a href="mailto:lucas@lucasjumalonpoker.ai" className="hover:text-white">lucas@lucasjumalonpoker.ai</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-zinc-500 font-mono">
        © {new Date().getFullYear()} LucasJumalonPoker.ai · Play responsibly. 18+
      </div>
    </footer>
  );
}
